<div class="admin-announcement-container">
  <mat-card class="main-container">
    <mat-card-title>
      <h1 class="card-title">Newsfeed</h1>
      <div class="actions-box">
        <mat-form-field appearance="outline" class="search-bar">
          <input matInput #search (keyup)="applyFilter($event.toString())" maxlength="256" placeholder="Search" />
          <mat-icon matSuffix>search</mat-icon>

          <mat-hint align="start">Example: Title, Last Modified By </mat-hint>
        </mat-form-field>
        <mat-card-actions>
          <button mat-stroked-button class="is-rounded" color="accent" [routerLink]="['../newsfeed/addnews']">
            <mat-icon>add</mat-icon> <span>Add New</span>
          </button>

          <button class="is-rounded" color="accent" mat-stroked-button [routerLink]="['../preview']">
            <mat-icon>remove_red_eye</mat-icon> <span>Preview</span>
          </button>
        </mat-card-actions>
      </div>
    </mat-card-title>
    <mat-card-content class="mat-elevation-z8">
      <table mat-table [dataSource]="dataSource" matSort>
        <!--- Note that these columns can be defined in any order.
                              The actual rendered columns are set as a property on the row definition" -->

        <!-- Weight Column -->
        <ng-container matColumnDef="Status">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
          <td mat-cell *matCellDef="let element">
            <span class="dot" [ngClass]="{
                        'dot-active': element.Name == 'Active',
                        'dot-closed': element.Name == 'Closed'
                      }">
            </span>
            {{ element.Name }}
          </td>
        </ng-container>
        <!-- Position Column -->
        <ng-container matColumnDef="Title">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Title</th>
          <td mat-cell *matCellDef="let element">{{ element.Title }}</td>
        </ng-container>

        <!-- Name Column -->
        <ng-container matColumnDef="Headline">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Headline</th>
          <td mat-cell *matCellDef="let element">{{ element.Headline }}</td>
        </ng-container>
        <ng-container matColumnDef="Publishdate">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            Publish Date
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.Publishdate |  date: 'shortDate'}}
          </td>
        </ng-container>

        <ng-container matColumnDef="ModifiedBy">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            Modified By
          </th>
          <td mat-cell *matCellDef="let element">{{ element.ModifiedBy }}</td>
        </ng-container>

        <ng-container matColumnDef="delete">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Delete</th>
          <td mat-cell *matCellDef="let element">
          
              <mat-icon class="delete-box" (click)="openDialog(element.NewsfeedID); $event.stopPropagation()">delete_forever</mat-icon>
   
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let element; columns: displayedColumns" [routerLink]="['/iap/newsfeed/addnews/', element.NewsfeedID]"></tr>
      </table>

      <mat-paginator [pageSizeOptions]="[5, 10, 20, 50, 100]" showFirstLastButtons> </mat-paginator>
    </mat-card-content>
  </mat-card>
</div>